import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { mobileContactOperations } from "./state";
import { authOperations } from "../Login/state";
import ContactTable from './ContactTable';
import { VIEW_CONTACT } from './routes';
import { MOBILE_CONTACT_LIST } from '../../../utils/constants';

class ContactList extends Component {

    componentDidMount() {
        this.props.setMobilePage(MOBILE_CONTACT_LIST);

        this.props.fetchDefault({
            customerCode1: this.props.user.mainNumber,
            customerCode2: this.props.user.branchNumber
        });

        this.props.getUnreadCount({
            customerCode1: this.props.user.mainNumber,
            customerCode2: this.props.user.branchNumber
        });
    }

    viewContact = (row) =>{
        this.props.history.push(VIEW_CONTACT + `/${row.contactNumber}`);
    } 

    render() {
        return (
            <Grid className="mobile-container">
                <Grid>
                    <ContactTable
                        list={this.props.tableList}
                        viewContact={this.viewContact}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.partnerCodes,
        tableList: state.mobileContact.list
    }
};

const mapDispatchToProps = {
    fetchDefault: mobileContactOperations.fetchDefault,
    getUnreadCount: mobileContactOperations.getUnreadCount,
    setMobilePage: authOperations.setMobilePage
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactList);